"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseCloudEventV1 = exports.Version = exports.DEFAULT_SOURCE = void 0;
exports.DEFAULT_SOURCE = 'Unknown';
var Version;
(function (Version) {
    Version["V1"] = "1.0";
})(Version = exports.Version || (exports.Version = {}));
class BaseCloudEventV1 {
    constructor(id) {
        this.time = new Date().toISOString();
        this.specversion = Version.V1;
        this.id = id;
    }
}
exports.BaseCloudEventV1 = BaseCloudEventV1;
//# sourceMappingURL=BaseCloudEvent.js.map